import gql from 'graphql-tag';
import apollo from 'src/features/apolloCustomer';
import i18n from 'src/features/i18n';

const mutation = gql`
mutation signIn($authId: String!, $token: String!){
  tokenSignIn(authId: $authId, token: $token) {
    token
    customer {
      id
      identified
      firstName
      lastName
      middleName
      description
      accounts {
        id
        provider
        providerId
      }
    }
  }
}`;

function parseAccount(item) {
  return {
    id: item.id,
    title: item.providerId,
    type: item.provider,
  };
}

function parseCustomer(item) {
  return {
    id: item.id,
    title: item.firstName,
    firstName: item.firstName,
    lastName: item.lastName,
    middleName: item.middleName,
    description: item.description,
    identified: !!item.identified,
    accounts: (item.accounts && item.accounts.map((res) => parseAccount(res))) || [],
  };
}

function signIn(authId, token) {
  return apollo.client.mutate({
    variables: {
      authId,
      token,
    },
    mutation,
  }).then((res) => ({
    token: res.data.tokenSignIn.token,
    customer: parseCustomer(res.data.tokenSignIn.customer),
  }))
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].message;
        throw i18n.t(errors);
      } else {
        throw err;
      }
    });
}

export default signIn;
